import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { RecipientsApi, RestApiError, type RecipientResponse, type RecipientUpdateRequest } from '@shared/api';

const updateRecipientEffect = createEffect((request: RecipientUpdateRequest) => RecipientsApi.updateRecipient(request));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(updateRecipientEffect.done, (_, data) => data.result ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateRecipientEffect.pending, (_, data) => data)
  .on(updateRecipientEffect.fail, () => false)
  .on(updateRecipientEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(updateRecipientEffect, () => null)
  // .on(updateRecipientEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(updateRecipientEffect.fail, (_, data) => {
    if (RestApiError.isRestApiError(data.error) && data.error.data.errorCode) return data.error.message;
    return 'Something went wrong while updating Recipient. Please try again.';
  })
  .on(updateRecipientEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $recipientUpdateStore = {
  events: {
    updateRecipient: updateRecipientEffect,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
